import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import Loader from 'v2/components/Loader/Loader';

const DEFAULT_LOADER_SIZE = 3;

interface Props {
  loading: boolean;
  message: string;
  children: React.ReactNode;
  loaderSize?: number;
}

const LoadingOverlay: React.FC<Props> = ({ loading, message, children, loaderSize = DEFAULT_LOADER_SIZE }) => (
  <Box sx={{ position: 'relative', height: '100%' }}>
    {loading && (
      <Box
        sx={(theme) => ({
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.custom.background.overlay
        })}
      >
        <Paper
          elevation={3}
          sx={{ borderRadius: 1, p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}
        >
          <Loader size={loaderSize} />
          <Typography variant="body1">{message}</Typography>
        </Paper>
      </Box>
    )}
    {children}
  </Box>
);

export default LoadingOverlay;
